module.exports = __webpack_public_path__ + "img/8.02060bb6.jpg";